/**
 * Design Tokens for Apartment Management Consultants Theme
 * 
 * Extends the base landing-page theme tokens with Apartment Management Consultants branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-landing-page/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Apartment Management Consultants brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Darken secondary so CTA button text (`text-secondary-foreground` on
    // `bg-secondary`) clears WCAG AA with margin — covers Header, Footer, and
    // CTASection. Parent `#358083` + white is only ~4.6:1 and is commonly
    // flagged on the small CTA labels.
    secondary: '#245d60',
    textOnSecondary: '#ffffff',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Apartment Management Consultants typography - customize these
    // heading: '"Your Heading Font", serif',
    // body: '"Your Body Font", sans-serif',
  },
};

export default tokens;
